module.exports = __webpack_public_path__ + "img/home_jobmule.f7865274.png";